<template>
  <div class="progress-user-info" :id="id" :style="`background-color:${color}; width:${progress}%`">
    <div class="fcc h-100">
      <div class="left fcc">
        <img v-if="icon && icon !== null && icon !== ''" :src="icon" class="user-icon" />
        <img v-else src="@/assets/images/users/default.png" class="user-icon" />
        <span class="user-info">
          {{ name }}
        </span>
        <!-- tooltip -->
      </div>
      <div class="remainig-days fcc" :style="`color:${color}`">5d</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
    },
    progress: {
      type: Number,
    },
    name: {
      type: String,
      default: 'حاج حسین',
    },
    id: {
      type: Number,
    },
    icon: {
      type: String,
    },
  },
 
}
</script>

<style scoped lang='scss'>
@import '../../../design/custom/components/_fancy_progressbar_content.scss';
</style>